module.exports = __webpack_public_path__ + "img/Photo_1__Grain_Industry_2007_5_43.c92f0dd7.jpg";